// Import videos for Mark
import hiMessageMarkEN from "../../assets/video/mark/hi_mark_en.mp4";
import hiMessageMarkID from "../../assets/video/mark/hi_mark_id.mp4";
import welcomeMessageMarkEN from "../../assets/video/mark/welcome_mark_en.mp4";
import welcomeMessageMarkID from "../../assets/video/mark/welcome_mark_id.mp4";
import sorryMessageMarkEN from "../../assets/video/mark/sorry_mark_en.mp4";
import sorryMessageMarkID from "../../assets/video/mark/sorry_mark_id.mp4";
import glitchMessageMark from "../../assets/video/mark/glitch_mark.mp4";
import talkMessageMark from "../../assets/video/mark/talk_mark.mp4";
import idleMessageMark from "../../assets/video/mark/idle_mark.mp4";
import case2MarkEN from "../../assets/video/mark/i_will_mark_en.mp4";
import case2MarkID from "../../assets/video/mark/i_will_mark_id.mp4";
import MarkVideo from "../../assets/video/mark/idle-talk-idle.mp4";

// Import videos for Joeie
import hiMessageJoeieEN from "../../assets/video/joeie/hi_joeie_en.mp4";
import hiMessageJoeieID from "../../assets/video/joeie/hi_joeie_id.mp4";
import welcomeMessageJoeieEN from "../../assets/video/joeie/welcome_joeie_en.mp4";
import welcomeMessageJoeieID from "../../assets/video/joeie/welcome_joeie_id.mp4";
import sorryMessageJoeieEN from "../../assets/video/joeie/sorry_joeie_en.mp4";
import sorryMessageJoeieID from "../../assets/video/joeie/sorry_joeie_id.mp4";
import glitchMessageJoeie from "../../assets/video/joeie/glitch_joeie.mp4";
import talkMessageJoeie from "../../assets/video/joeie/talk_joeie.mp4";
import idleMessageJoeie from "../../assets/video/joeie/idle_joeie.mp4";
import case2JoeieEN from "../../assets/video/joeie/i_will_joeie_en.mp4";
import case2JoeieID from "../../assets/video/joeie/i_will_joeie_id.mp4";
import JoeieVideo from "../../assets/video/joeie/idle-talk-idle.mp4";

// Import videos for Dila
import hiMessageDilaEN from "../../assets/video/dila/hi_dila_en.mp4";
import hiMessageDilaID from "../../assets/video/dila/hi_dila_id.mp4";
import welcomeMessageDilaEN from "../../assets/video/dila/welcome_dila_en.mp4";
import welcomeMessageDilaID from "../../assets/video/dila/welcome_dila_id.mp4";
import sorryMessageDilaEN from "../../assets/video/dila/sorry_dila_en.mp4";
import sorryMessageDilaID from "../../assets/video/dila/sorry_dila_id.mp4";
import glitchMessageDila from "../../assets/video/dila/glitch_dila.mp4";
import talkMessageDila from "../../assets/video/dila/talk_dila.mp4";
import idleMessageDila from "../../assets/video/dila/idle_dila.mp4";
import case2DilaEN from "../../assets/video/dila/i_will_dila_en.mp4";
import case2DilaID from "../../assets/video/dila/i_will_dila_id.mp4";
import DilaVideo from "../../assets/video/dila/idle-talk-idle.mp4";

// Import videos for Hanna
import hiMessageHannaEN from "../../assets/video/hanna/hi_hanna_en.mp4";
import hiMessageHannaID from "../../assets/video/hanna/hi_hanna_id.mp4";
import welcomeMessageHannaEN from "../../assets/video/hanna/welcome_hanna_en.mp4";
import welcomeMessageHannaID from "../../assets/video/hanna/welcome_hanna_id.mp4";
import sorryMessageHannaEN from "../../assets/video/hanna/sorry_hanna_en.mp4";
import sorryMessageHannaID from "../../assets/video/hanna/sorry_hanna_id.mp4";
import glitchMessageHanna from "../../assets/video/hanna/glitch_hanna.mp4";
// import talkMessageHanna from "../../assets/video/hanna/talk_hanna.mp4";
import idleMessageHanna from "../../assets/video/hanna/idle_hanna.mp4";
import case2HannaEN from "../../assets/video/hanna/i_will_hanna_en.mp4";
import case2HannaID from "../../assets/video/hanna/i_will_hanna_id.mp4";
import HannaVideo from "../../assets/video/hanna/idle-talk-idle.mp4";

const getVideoConfig = () => {
  const pathSegments = window.location.pathname.split("/");
  const avatar = pathSegments[pathSegments.length - 1];
  const language = sessionStorage.getItem("language") || "English";
  const videoUrl = sessionStorage.getItem("videoUrl");

  const videos = {
    hiMessage: null,
    welcomeMessage: null,
    sorryMessage: null,
    glitchMessage: null,
    talkMessage: null,
    idleMessage: null,
    case2: null,
    noActivityMessage: null,
    hiText: null,
    welcomeText: null,
    sorryText: null,
    glitchText: null,
    case2Text: null,
    inActiveText: null,
  };

  switch (avatar) {
    case "Mark":
      videos.hiMessage =
        language === "English" ? hiMessageMarkEN : hiMessageMarkID;
      videos.welcomeMessage =
        language === "English" ? welcomeMessageMarkEN : welcomeMessageMarkID;
      videos.sorryMessage =
        language === "English" ? sorryMessageMarkEN : sorryMessageMarkID;
      videos.glitchMessage = glitchMessageMark;
      videos.talkMessage = talkMessageMark;
      videos.idleMessage = idleMessageMark;
      videos.case2 = language === "English" ? case2MarkEN : case2MarkID;
      // videos.noActivityMessage =
      //   language === "English" ? noActivityMarkEn : noActivityMarkId;
      videos.noActivityMessage = language === "English" ? talkMessageMark : "";
      videos.idleTalk = MarkVideo;

      videos.hiText =
        language === "English"
          ? "Hi, how can I address you?"
          : "Halo, bagaimana saya dapat memanggil Anda?";
      videos.welcomeText =
        language === "English"
          ? "Welcome to Star Enterprise Network! My name is Mark."
          : "Selamat datang di Jaringan Perusahaan Star! Nama saya Mark.";
      videos.sorryText =
        language === "English"
          ? "Sorry, bad reception due to cosmic rain here. Let me welcome you again..."
          : "Maaf, koneksi kurang bagus disini karena hujan kosmik. Izinkan saya menyambutmu lagi...";
      videos.glitchText =
        language === "English" ? "Reconnecting..." : "Menghubungkan kembali...";
      videos.case2Text =
        language === "English"
          ? "I will be your assistant for any of your inquiries..."
          : "Saya adalah asisten yang akan membantu menjawab pertanyaan-pertanyaan dari Anda...";
      videos.inActiveText =
        language === "English"
          ? "Hi, are you still there? anything else on your mind?"
          : "Halo, apakah kamu masih disana? Apakah ada lagi yang ingin kamu ketahui?";
      break;
    case "Joeie":
      videos.hiMessage =
        language === "English" ? hiMessageJoeieEN : hiMessageJoeieID;
      videos.welcomeMessage =
        language === "English" ? welcomeMessageJoeieEN : welcomeMessageJoeieID;
      videos.sorryMessage =
        language === "English" ? sorryMessageJoeieEN : sorryMessageJoeieID;
      videos.glitchMessage = glitchMessageJoeie;
      videos.talkMessage = talkMessageJoeie;
      videos.idleMessage = idleMessageJoeie;
      videos.case2 = language === "English" ? case2JoeieEN : case2JoeieID;
      // videos.noActivityMessage =
      //   language === "English" ? noActivityJoeieEn : noActivityJoeieId;
      videos.noActivityMessage = language === "English" ? talkMessageJoeie : "";
      videos.idleTalk = JoeieVideo;

      videos.hiText =
        language === "English"
          ? "Hi, how can I address you?"
          : "Halo, bagaimana saya dapat memanggil Anda?";
      videos.welcomeText =
        language === "English"
          ? "Welcome to Star Enterprise Network! My name is Joeie."
          : "Selamat datang di Jaringan Perusahaan Star! Nama saya Joeie.";
      videos.sorryText =
        language === "English"
          ? "Sorry, bad reception due to cosmic rain here. Let me welcome you again..."
          : "Maaf, koneksi kurang bagus disini karena hujan kosmik. Izinkan saya menyambutmu lagi...";
      videos.glitchText =
        language === "English" ? "Reconnecting..." : "Menghubungkan kembali...";
      videos.case2Text =
        language === "English"
          ? "I will be your assistant for any of your inquiries..."
          : "Saya adalah asisten yang akan membantu menjawab pertanyaan-pertanyaan dari Anda...";
      videos.inActiveText =
        language === "English"
          ? "Hi, are you still there? anything else on your mind?"
          : "Halo, apakah kamu masih disana? Apakah ada lagi yang ingin kamu ketahui?";
      break;
    case "Dila":
    case "Dilla":
      videos.hiMessage =
        language === "English" ? hiMessageDilaEN : hiMessageDilaID;
      videos.welcomeMessage =
        language === "English" ? welcomeMessageDilaEN : welcomeMessageDilaID;
      videos.sorryMessage =
        language === "English" ? sorryMessageDilaEN : sorryMessageDilaID;
      videos.glitchMessage = glitchMessageDila;
      videos.talkMessage = talkMessageDila;
      videos.idleMessage = idleMessageDila;
      videos.case2 = language === "English" ? case2DilaEN : case2DilaID;
      // videos.noActivityMessage =
      //   language === "English" ? noActivityDilaEn : noActivityDilaId;
      videos.noActivityMessage = language === "English" ? talkMessageDila : "";
      videos.idleTalk = DilaVideo;

      videos.hiText =
        language === "English"
          ? "Hi, how can I address you?"
          : "Halo, bagaimana saya dapat memanggil Anda?";
      videos.welcomeText =
        language === "English"
          ? "Welcome to Star Enterprise Network! My name is Dila."
          : "Selamat datang di Jaringan Perusahaan Star! Nama saya Dila.";
      videos.sorryText =
        language === "English"
          ? "Sorry, bad reception due to cosmic rain here. Let me welcome you again..."
          : "Maaf, koneksi kurang bagus disini karena hujan kosmik. Izinkan saya menyambutmu lagi...";
      videos.glitchText =
        language === "English" ? "Reconnecting..." : "Menghubungkan kembali...";
      videos.case2Text =
        language === "English"
          ? "I will be your assistant for any of your inquiries..."
          : "Saya adalah asisten yang akan membantu menjawab pertanyaan-pertanyaan dari Anda...";
      videos.inActiveText =
        language === "English"
          ? "Hi, are you still there? anything else on your mind?"
          : "Halo, apakah kamu masih disana? Apakah ada lagi yang ingin kamu ketahui?";
      break;
    case "Hanna":
      videos.hiMessage =
        language === "English" ? hiMessageHannaEN : hiMessageHannaID;
      videos.welcomeMessage =
        language === "English" ? welcomeMessageHannaEN : welcomeMessageHannaID;
      videos.sorryMessage =
        language === "English" ? sorryMessageHannaEN : sorryMessageHannaID;
      videos.glitchMessage = glitchMessageHanna;
      videos.talkMessage = videoUrl;
      videos.idleMessage = idleMessageHanna;
      videos.case2 = language === "English" ? case2HannaEN : case2HannaID;
      // videos.noActivityMessage =
      //   language === "English" ? noActivityHannaEn : "";
      videos.noActivityMessage = language === "English" ? videoUrl : "";
      videos.idleTalk = HannaVideo;

      videos.hiText =
        language === "English"
          ? "Hi, how can I address you?"
          : "Halo, bagaimana saya dapat memanggil Anda?";
      videos.welcomeText =
        language === "English"
          ? "Welcome to Star Enterprise Network! My name is Hanna."
          : "Selamat datang di Jaringan Perusahaan Star! Nama saya Hanna.";
      videos.sorryText =
        language === "English"
          ? "Sorry, bad reception due to cosmic rain here. Let me welcome you again..."
          : "Maaf, koneksi kurang bagus disini karena hujan kosmik. Izinkan saya menyambutmu lagi...";
      videos.glitchText =
        language === "English" ? "Reconnecting..." : "Menghubungkan kembali...";
      videos.case2Text =
        language === "English"
          ? "I will be your assistant for any of your inquiries..."
          : "Saya adalah asisten yang akan membantu menjawab pertanyaan-pertanyaan dari Anda...";
      videos.inActiveText =
        language === "English"
          ? "Hi, are you still there? anything else on your mind?"
          : "Halo, apakah kamu masih disana? Apakah ada lagi yang ingin kamu ketahui?";
      break;
    default:
      console.error("Unknown avatar or language");
  }

  // console.log("videos-config", videos.talkMessage);
  return videos;
};

export default getVideoConfig;
